import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Permission from "./pages/Permission";
import ChangePassword from "./pages/ChangePassword";
// -----------
import { useEffect } from "react";
import MainLayout from "./components/layout/mainLayout";

// import Physicsformulas from "./pages/testPhysicsformulas";
import AnimationChart from "../src/components/charts/CircleChart";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermCondition from "./pages/TermCondition";
import PolicyTracking from "./pages/PolicyTracking";
import ManageUser from "./pages/ManageUser";
import UserPermission from "./pages/UserPermission";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./components/cssDynamic/MenuTab.css";
import "./components/cssDynamic/Header.css";
import "./components/cssDynamic/Footer.css";
import "./components/cssDynamic/tableData.css";
import "./components/cssDynamic/buttons.css";
import "./components/cssDynamic/gridCard.css";
import "./components/cssDynamic/fontsData.css";
import "./components/cssDynamic/permission.css";
import "./components/cssDynamic/texts.css";
import "./components/cssDynamic/process.css";
import "./components/progressbar/progress.css";
import PrivateRoute  from  "./components/privateRoute/privateRoute"
import { AuthProvider } from './context/AuthContext'
import { ProfileProvider } from "./context/ProfileContext";
import Shortcut from "./pages/Shortcut";

import {
  textSearchBtn,
  textResetBtn,
  textCreateBtn,
  colorSearchBtn,
  colorResetBtn,
  colorCreateBtn,
  iconSearchBtn,
  iconResetBtn,
  iconCreateBtn,
  hoverSearchBtn,
  hoverResetBtn,
  hoverCreateBtn,
  textSaveBtn,
  textCancleBtn,
  colorSaveBtn,
  colorCancleBtn,
  hoverSaveBtn,
  hoverCancleBtn,
  colorEditBtns,
  hoverEditBtns
} from "./components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "./components/useDynamic/Button_DynamicStyle";
import HeroBannerHome from "./pages/HeroBannerHome";
import HeroBannerOfficer from "./pages/HeroBannerOfficer";
import HeroBannerCondo from "./pages/HeroBannerCondo";
import HeroBannerRetail from "./pages/HeroBannerRetail";
import HeroBannerPromotion from "./pages/HeroBannerPromotion";
import HeadBanner from "./pages/HeadBanner";
import CRCTower from "./pages/CRCTower";
import MThaiTower from "./pages/MThaiTower";
import CapitalTower from "./pages/CapitalTower";
import RetailCenterDetail from "./pages/RetailCenterDetail";
import Directory from "./pages/Directory";
import CondoManage from "./pages/CondoManage";
import CondoRent from "./pages/CondoRent";
import CondoSale from "./pages/CondoSale";
import Promotion from "./pages/Promotion";
import Privilege from "./pages/Privilege";
import News from "./pages/News";
import Event from "./pages/Event";
import ContentCareer from "./pages/ContentCareer";
import JobPosition from "./pages/JobPosition";
import JobApplicants from "./pages/JobApplicants";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import BiddingInformation from "./pages/BiddingInformation";
import BiddingWinning from "./pages/BiddingWinning";
import CustomerCare from "./pages/CustomerCare";
import ClubLounge from "./pages/ClubLounge";
import ShuttleBus from "./pages/ShuttleBus";
import Carpark from "./pages/Carpark";
import SocialMedia from "./pages/SocialMedia";
import UserManage from "./pages/UserManage";
import RoleManage from "./pages/RoleManage";
import Profile from "./pages/Profile";
import AddEditUser from "./pages/addEdit/AddEditUser";
import AddEditRole from "./pages/addEdit/AddEditRole";
import Home from "./pages/Home";
import AddEditJobPosition from "./pages/addEdit/AddEditJobPosition";
import ViewJobApplicants from "./pages/viewPage/ViewJobApplicants";
import AddEditBiddingInfo from "./pages/addEdit/AddEditBiddingInfo";
import AddEditBiddingWinning from "./pages/addEdit/AddEditBiddingWinning";
import AddEditBannerHome from "./pages/addEdit/AddEditBannerHome";
import AddEditBannerOfficer from "./pages/addEdit/AddEditBannerOfficer";
import AddEditBannerCondo from "./pages/addEdit/AddEditBannerCondo";
import AddEditBannerPromotion from "./pages/addEdit/AddEditBannerPromotion";
import AddEditBannerRetail from "./pages/addEdit/AddEditBannerRetail";
import EditHeadBanner from "./pages/addEdit/EditHeadBanner";
import AddEditDirectory from "./pages/addEdit/AddEditDirectory";
import AddEditPromotion from "./pages/addEdit/AddEditPromotion";
import AddEditPrivilege from "./pages/addEdit/AddEditPrivilege";
import AddEditNews from "./pages/addEdit/AddEditNews";
import AddEditEvent from "./pages/addEdit/AddEditEvent";

function App() {

  useButtonDynamicStyles(
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
);
  const [session, setSession] = useState(
    sessionStorage.getItem("tokenBackoffice")
  );
  const [local, setLocal] = useState(localStorage.getItem("tokenBackoffice"));

  useEffect(
    () => {
      // if (!session && !local) {
      //   sessionStorage.clear();
      //   localStorage.clear();
      //   if (window.location.pathname !== "/backoffice/login") {
      //     window.location.href = "/backoffice/login";
      //   }
      // }
      // console.log("sessionStorage", sessionStorage.getItem("tokenBackoffice"));
      // console.log("localStorage", localStorage.getItem("tokenBackoffice"));
    },
    []
    // [session, local]
  );

  return (
    <div className="wrapper">
      <BrowserRouter basename={process.env.REACT_APP_NODE_ENV != 'prod' ? "/backoffice" : '/'} >
      {/* <BrowserRouter > */}
        <AuthProvider>
          <ProfileProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace={true} />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/changePassword" element={<ChangePassword />} />
              {/* --------- */}
              <Route path="/infoPermission" element={<Permission />} />
              <Route path="/pageAnimationChart" element={<AnimationChart />} />
              {/* --------- */}
              <Route path="/infoShortcuts" element={<Shortcut/>}/>
              {/* --------- */}
              <Route path="infoHome" element={<Home/>}/>
              {/* -----Banner---- */}
              <Route path="/infoHeroBannerHome" element={<HeroBannerHome/>}/>
              <Route path="/infoHeroBannerOfficer" element={<HeroBannerOfficer/>}/>
              <Route path="/infoHeroBannerCondo" element={<HeroBannerCondo/>}/>
              <Route path="/infoHeroBannerRetail" element={<HeroBannerRetail/>}/>
              <Route path="/infoHeroBannerPromotion" element={<HeroBannerPromotion/>}/>
              <Route path="/infoHeadBanner" element={<HeadBanner/>}/>
              <Route path="/a&eInfoBannerHome" element={<AddEditBannerHome/>}/>
              <Route path="/a&eInfoBannerOfficer" element={<AddEditBannerOfficer/>}/>
              <Route path="/a&eInfoBannerCondo" element={<AddEditBannerCondo/>}/>
              <Route path="/a&eInfoBannerPromotion" element={<AddEditBannerPromotion/>}/>
              <Route path="/a&eInfoBannerRetail" element={<AddEditBannerRetail/>}/>
              <Route path="/eInfoHeadBanner" element={<EditHeadBanner/>}/>
              {/* -----Business---- */}
              <Route path="/infoCRCTower" element={<CRCTower/>}/>
              <Route path="/infoMThaiTower" element={<MThaiTower/>}/>
              <Route path="/infoCapitalTower" element={<CapitalTower/>}/>
              <Route path="/infoRetailCenterDetail" element={<RetailCenterDetail/>}/>
              <Route path="/infoDirectory" element={<Directory/>}/>
              <Route path="/a&eInfoDirectory" element={<AddEditDirectory/>}/>
              <Route path="/infoCondoManage" element={<CondoManage/>}/>
              <Route path="/infoCondoRent" element={<CondoRent/>}/>
              <Route path="/infoCondoSale" element={<CondoSale/>}/>
              {/* -----Promotion&Privilege---- */}
              <Route path="/infoPromotion" element={<Promotion/>}/>
              <Route path="/a&eInfoPromotion" element={<AddEditPromotion/>}/>
              <Route path="/infoPrivilege" element={<Privilege/>}/>
              <Route path="/a&eInfoPrivilege" element={<AddEditPrivilege/>}/>
              {/* -----Promotion&Privilege---- */}
              <Route path="/infoNews" element={<News/>}/>
              <Route path="/a&eInfoNews" element={<AddEditNews/>}/>
              <Route path="/infoEvent" element={<Event/>}/>
              <Route path="/a&eInfoEvent" element={<AddEditEvent/>}/>
              {/* -----Career Job---- */}
              <Route path="/infoContentCareer" element={<ContentCareer/>}/>
              <Route path="/infoJobPosition" element={<JobPosition/>}/>
              <Route path="/a&eInfoJobPosition" element={<AddEditJobPosition/>}/>
              <Route path="/infoJobApplicants" element={<JobApplicants/>}/>
              <Route path="/viewJobApplicant" element={<ViewJobApplicants/>} />

              <Route path="/infoContactUs" element={<ContactUs/>}/>
              <Route path="/infoAboutUs" element={<AboutUs/>}/>

              {/* -----Open Tendering Project---- */}
              <Route path="/infoBiddingInformation" element={<BiddingInformation/>}/>
              <Route path="/infoBiddingWinning" element={<BiddingWinning/>}/>
              <Route path="/a&eInfoBiddingInfo" element={<AddEditBiddingInfo/>}/>
              <Route path="/a&eInfoBiddingWinning" element={<AddEditBiddingWinning/>}/>

              {/* -----Our Service & Privilege---- */}
              <Route path="/infoCustomerCare" element={<CustomerCare/>}/>
              <Route path="/infoClubLounge" element={<ClubLounge/>}/>
              <Route path="/infoShuttleBus" element={<ShuttleBus/>}/>
              <Route path="/infoCarpark" element={<Carpark/>}/>

              <Route path="/infoSocialMedia" element={<SocialMedia/>}/>

              {/* -----Admin User----- */}
              <Route path="/infoUserManage" element={<UserManage/>}/>
              <Route path="/infoRoleManage" element={<RoleManage/>}/>
              <Route
                path="/a&eInfoUserManage"
                element={<AddEditUser /> }
              />
              <Route
                path="/a&eInfoRoleManage"
                element={<AddEditRole /> }
              />

              <Route path="/infoPrivacyPolicy" element={<PrivacyPolicy/>}/>
              <Route path="/infoTermCondition" element={<TermCondition/>}/>
              <Route path="/infoPolicyTracking" element={<PolicyTracking/>}/>
              <Route path="/infoManageUser" element={<ManageUser/>}/>
              <Route path="/infoUserPermission" element={<UserPermission/>}/>

              <Route path="/infoProfile" element={<Profile/>}/>
            </Routes>
        </ProfileProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
library.add(fab, fas, far)